import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Stack,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const DiscoverCandidates = () => {
  const [functions, setFunctions] = useState([]);
  const [selectedFunctionId, setSelectedFunctionId] = useState("");
  const [roles, setRoles] = useState([]);
  const [selectedRoleIds, setSelectedRoleIds] = useState([]);
  const [loadingFunctions, setLoadingFunctions] = useState(false);
  const [loadingRoles, setLoadingRoles] = useState(false);
  const [roleMenuOpen, setRoleMenuOpen] = useState(false);

  const navigate = useNavigate();

  const token = Cookies.get("token");

  useEffect(() => {
    const fetchFunctions = async () => {
      setLoadingFunctions(true);
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/profile/job-functions`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (res.ok) {
        const data = await res.json();
        setFunctions(data);
      }
      setLoadingFunctions(false);
    };
    fetchFunctions();
  }, [token]);

  useEffect(() => {
    if (!selectedFunctionId) {
      setRoles([]);
      setSelectedRoleIds([]);
      return;
    }

    const fetchRoles = async () => {
      setLoadingRoles(true);
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/profile/job-roles/${selectedFunctionId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (res.ok) {
        const data = await res.json();
        setRoles(data);
      }
      setLoadingRoles(false);
    };

    fetchRoles();
  }, [selectedFunctionId, token]);

  const filteredFunctions = functions;
  const filteredRoles = roles;

  const handleFunctionChange = (event) => {
    setSelectedFunctionId(event.target.value);
    setSelectedRoleIds([]);
  };

  const handleRoleChange = (event) => {
    const value = event.target.value;
    setSelectedRoleIds(typeof value === "string" ? value.split(",") : value);
  };

  const handleSearch = () => {
    if (!selectedFunctionId || selectedRoleIds.length === 0) return;
    const params = new URLSearchParams({
      functionId: selectedFunctionId,
      roleIds: selectedRoleIds.join(","),
    });
    navigate(`/corporate/discover-candidates/search?${params.toString()}`);
  };

  const disableSearch =
    !selectedFunctionId || selectedRoleIds.length === 0 || loadingRoles;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ mb: 1 }}>
        Discover
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 3 }}>
        Discover your perfect candidates per industry!
      </Typography>

      <Paper sx={{ p: 4, borderRadius: 3, maxWidth: 680 }} elevation={1}>
        <Stack spacing={3}>
          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Choose a function
            </Typography>
            {/* <Chip label={functions.length} size="small" color="primary" /> */}
          </Box>

          <FormControl fullWidth disabled={loadingFunctions}>
            <InputLabel id="function-select-label">Function</InputLabel>
            <Select
              labelId="function-select-label"
              value={selectedFunctionId}
              label="Function"
              onChange={handleFunctionChange}
            >
              {loadingFunctions && (
                <MenuItem value="">
                  <CircularProgress size={20} sx={{ mr: 2 }} /> Loading...
                </MenuItem>
              )}
              {!loadingFunctions && filteredFunctions.length === 0 && (
                <MenuItem value="" disabled>
                  No functions found
                </MenuItem>
              )}
              {!loadingFunctions &&
                filteredFunctions.map((func) => (
                  <MenuItem key={func.id} value={func.id}>
                    {func.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {selectedFunctionId && (
            // <FormControl fullWidth disabled={loadingRoles}>
            //   <InputLabel id="role-select-label">Roles</InputLabel>
            //   <Select
            //     labelId="role-select-label"
            //     multiple
            //     value={selectedRoleIds}
            //     label="Roles"
            //     onChange={handleRoleChange}
            //     renderValue={(selected) =>
            //       selected
            //         .map(
            //           (roleId) =>
            //             roles.find((role) => String(role.id) === String(roleId))?.name
            //         )
            //         .filter(Boolean)
            //         .join(", ") || "Select roles"
            //     }
            //   >
            //     {loadingRoles && (
            //       <MenuItem value="" disabled>
            //         <CircularProgress size={20} sx={{ mr: 2 }} /> Loading roles...
            //       </MenuItem>
            //     )}
            //     {!loadingRoles && filteredRoles.length === 0 && (
            //       <MenuItem value="" disabled>
            //         No roles found for this function
            //       </MenuItem>
            //     )}
            //     {!loadingRoles &&
            //       filteredRoles.map((role) => (
            //         <MenuItem key={role.id} value={role.id}>
            //           {role.name}
            //         </MenuItem>
            //       ))}
            //   </Select>
            // </FormControl>

            <FormControl fullWidth disabled={loadingRoles}>
              <InputLabel id="role-select-label">Roles</InputLabel>
              <Select
                labelId="role-select-label"
                multiple
                value={selectedRoleIds}
                label="Roles"
                onChange={(e) => {
                  handleRoleChange(e);
                  setRoleMenuOpen(false); // Close after selecting
                }}
                open={roleMenuOpen}
                onOpen={() => setRoleMenuOpen(true)}
                onClose={() => setRoleMenuOpen(false)}
                renderValue={(selected) =>
                  selected
                    .map(
                      (roleId) =>
                        roles.find((role) => String(role.id) === String(roleId))
                          ?.name,
                    )
                    .filter(Boolean)
                    .join(", ") || "Select roles"
                }
              >
                {loadingRoles && (
                  <MenuItem value="" disabled>
                    <CircularProgress size={20} sx={{ mr: 2 }} /> Loading
                    roles...
                  </MenuItem>
                )}
                {!loadingRoles && filteredRoles.length === 0 && (
                  <MenuItem value="" disabled>
                    No roles found for this function
                  </MenuItem>
                )}
                {!loadingRoles &&
                  filteredRoles.map((role) => (
                    <MenuItem
                      key={role.id}
                      value={role.id}
                      onClick={() => setRoleMenuOpen(false)} // Close on click
                    >
                      {role.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              disabled={disableSearch}
            >
              Search candidates
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
};

export default DiscoverCandidates;
